export const getValueInRange = (value: number, maxValue: number, minValue: number, circular: boolean): number => {
  let newValue = value
  const range = maxValue - minValue

  if (newValue < minValue) {
    newValue = circular ? maxValue - ((minValue - newValue - 1) % range) : minValue
  }

  if (newValue > maxValue) {
    newValue = circular ? minValue + ((newValue - maxValue - 1) % range) : maxValue
  }

  return newValue || minValue
}

export const getElapsedSeconds = (initialDate: number, finalDate: number): number => {
  const now = Date.now()
  const date = finalDate && finalDate < now ? finalDate : now
  return Math.max(Math.floor((date - initialDate) / 1000), 0)
}
